import { render, staticRenderFns } from "./Material.vue?vue&type=template&id=21d6a946&"
import script from "./Material.vue?vue&type=script&lang=js&"
export * from "./Material.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports